$(document).ready(function( $ ) {
  
  //bxslider for book
  if($("body").hasClass("found-at-sea")) {
    $('ul#productslides').bxSlider({
		onSliderLoad: function(){
        	$("ul#productslides").css("visibility", "visible");
      	}
    });
  };
  
  //Variables
  var $navBtn = $("#nav");
  var $navOpen = $("#mobilenav nav");
  var open = 0;
  
  //On click
  $navBtn.click(function() {
    checkOpen();
  });
  
  //Navigation
  function openNav() {
    $navOpen.stop().slideDown();
  };
  
  function closeNav() {
    $navOpen.stop().slideUp();
  };
  
  function checkOpen() {
    if(open == 0) {
      openNav();
      open = 1;
    } else {
      closeNav();
      open = 0;
    }; 
  };
  
  //*Attempt* to disable right click saving of images. Damn you view sourcers.
  $('img').bind('contextmenu', function(e) {
      return false;
  }); 
});
// (c) Copyright 2014 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
// See http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
var Shopify = Shopify || {};

Shopify.optionsMap = {};

Shopify.updateOptionsInSelector = function(selectorIndex) {
  
  // Once you select something, remove the disabling of the submit and 3rd dropdownlist
  $("input[type='submit'], .single-option-selector:eq(2)").removeAttr("disabled");
  
  // And remove my dummy options
  $(".single-option-selector").each(function(n, obj){
    $(obj).find('option[value="-"]').remove();
  });
  
  
  
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = jQuery('.single-option-selector:eq(0)');
      break;
    case 1:
      var key = jQuery('.single-option-selector:eq(0)').val();
      var selector = jQuery('.single-option-selector:eq(1)');
      break;
    case 2:
      var key = jQuery('.single-option-selector:eq(0)').val();  
      key += ' / ' + jQuery('.single-option-selector:eq(1)').val();
      var selector = jQuery('.single-option-selector:eq(2)');
  }
  
  var initialValue = selector.val();
  selector.empty();    
  var availableOptions = Shopify.optionsMap[key];
  for (var i=0; i<availableOptions.length; i++) {
    var option = availableOptions[i];
    var newOption = jQuery('<option></option>').val(option).html(option);
    selector.append(newOption);
  }
  jQuery('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if (jQuery.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').show().find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.val(initialValue);
  }
  selector.trigger('change');  
  
};

Shopify.linkOptionSelectors = function(product) {
  // Building our mapping object.
  for (var i=0; i<product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
      Shopify.optionsMap['root'].push(variant.option1);
      Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }  
  
  // Update options right away.
  $(".single-option-selector:eq(0)").change(function() {
    if ($(".single-option-selector:eq(1)").val()!="-")
      Shopify.updateOptionsInSelector(2);
    return true;
  });
  
  $(".single-option-selector:eq(1)").change(function() {
    if ($(".single-option-selector:eq(0)").val()!="-")
      Shopify.updateOptionsInSelector(2);
    return true;
  });
  
  
  // A collection of all headers
  var headerList = ""; 
  
  
  // For each available option do
  $(".single-option-selector").each(function(n, obj){
    var $this = $(obj);
    
    // Get the header for this category from the label of this select
    var header = $this.prev().text();
    
    // If not the third option (because apparently the previous code didn't care for this either)
    if (n<2){
      // Add to the headerList
      
      headerList += (headerList==""?"":" / ")+ header;
      
      // and add as primary option
      $this.prepend('<option value="-" selected="selected">' + header + '..</option>');
    } else {
      // add as primary option, but say that x,y has to selected first
      $this.prepend('<option value="-" selected="selected">' + header + '..</option>');
      // and disable the whole list (dropdownlist nr3)
      $this.attr("disabled","disabled");
    }
  });
  
  // Also initially disable the submit button, because this shouldn't be available with all the
  // Select a xxx around.
  $("input[type='submit']").attr("disabled","disabled");
};